"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const rolesService = {
  getRoles: function (options) {
    return api.get("/Roles", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
};

export default rolesService;
